// Mock data for J.B.F. Antiques & Gallery - REAL INVENTORY from Facebook

export const featuredAntiques = [
  {
    id: 1,
    name: "Bronze Signed 'MENE' - Gamekeeper with Gun Dog",
    category: "sculpture",
    description: "Exquisite bronze sculpture signed 'MENE' featuring a gamekeeper and his gun dog on a marble base. A classic piece by the renowned artist Pierre-Jules Mêne.",
    price: "£370",
    image: "/images/bronze-mene-1.jpg",
    year: "19th Century",
    condition: "Excellent"
  },
  {
    id: 2,
    name: "Art Deco Frosted Lucite Dancing Lady Statue",
    category: "sculpture",
    description: "Beautiful Art Deco style frosted lucite statue of a dancing lady. Standing at 64cm high, this elegant piece captures the grace and movement of the Art Deco period.",
    price: "£120",
    image: "/images/lucite-statue-1.jpg",
    year: "Art Deco",
    condition: "Excellent"
  },
  {
    id: 3,
    name: "18ct White Gold Diamond Earrings",
    category: "jewelry",
    description: "Beautiful 18ct white gold 750 diamond stud earrings. Elegant and timeless design. Code: 2603-190",
    price: "£380",
    image: "/images/diamond-earrings-1.jpg",
    year: "Modern",
    condition: "Excellent"
  }
];

export const galleryItems = [
  ...featuredAntiques,
  {
    id: 6,
    name: "9ct Gold Diamond Ring",
    category: "jewelry",
    description: "Beautiful 9ct gold ring featuring a diamond in a subtle, elegant design. Perfect for everyday wear or special occasions.",
    price: "£180",
    image: "/images/diamond-ring-1.jpg",
    year: "Modern",
    condition: "Excellent"
  },
  {
    id: 7,
    name: "925 Silver Curb Chain Link Bracelet",
    category: "jewelry",
    description: "Elegant 925 silver curb chain link bracelet with lobster clasp. Classic design with beautiful weight and shine.",
    price: "£20",
    image: "/images/silver-bracelet-1.jpg",
    year: "Modern",
    condition: "Excellent"
  },
  {
    id: 21,
    name: "925 Sterling Silver St Christopher Pendant & Chain",
    category: "jewelry",
    description: "925 sterling silver St Christopher round pendant on a 925 silver chain. Traditional depiction of St. Christopher carrying the Christ child across a river. Beautiful enamel detailing in blue, pink and green.",
    price: "£30",
    image: "/images/st-christopher-925-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 22,
    name: "Vintage Citizen Clariti Women's Quartz Watch",
    category: "jewelry",
    description: "Vintage Citizen Clariti women's quartz watch. Water resistant. Beautiful octagon face on a two tone metal link bracelet. A stylish and elegant timepiece.",
    price: "£75",
    image: "/images/citizen-watch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 23,
    name: "Silver St Christopher Pendant",
    category: "jewelry",
    description: "Silver pendant of St Christopher. Depicts the legend of Saint Christopher carrying the Christ Child across a dangerous river. Marked 'Silver' on reverse. Code: 2411-5.",
    price: "£10",
    image: "/images/st-christopher-silver-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 24,
    name: "Vintage Utex Swiss Made Apero Jewels Military Watch",
    category: "jewelry",
    description: "Vintage Apero Jewels watch on a black leather cuff strap. Style often associated with military use. Utex Swiss made mechanical watch with waterproof face and luminous hands.",
    price: "£45",
    image: "/images/utex-watch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 25,
    name: "Nataraja Shiva Amulet Pendant",
    category: "jewelry",
    description: "Nataraja Shiva amulet pendant. Depicting the Hindu deity Shiva as the divine cosmic dancer. Intricate brass detailing within a circular flame border.",
    price: "£25",
    image: "/images/nataraja-pendant-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 26,
    name: "Smiths Empire Pocket Watch *WORKING*",
    category: "jewelry",
    description: "Working Smiths Empire pocket watch. Features a contrasting black and white dial with large hands and numerals for legibility. Produced by Smiths from the post-WWII era up until the late 1970s.",
    price: "£30",
    image: "/images/smiths-pocket-watch-1.jpg",
    year: "1950s",
    condition: "Good"
  },
  {
    id: 34,
    name: "Silver and 9ct Gold Eternity Ring",
    category: "jewelry",
    description: "Silver and 9ct Gold eternity ring. Beautiful detailing and engraving. A stunning piece combining two precious metals in an elegant design.",
    price: "£85",
    image: "/images/eternity-ring-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 35,
    name: "925 Silver St Christopher Pendant (Boxed)",
    category: "jewelry",
    description: "925 silver St Christopher pendant. Depicts the Christian legend of Saint Christopher carrying the Christ child across a river. Presented in original box.",
    price: "£30",
    image: "/images/st-christopher-boxed-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 36,
    name: "Vintage 925 Silver & 9ct Gold Scottish Stag Pin",
    category: "jewelry",
    description: "Vintage 925 silver with 9ct rolled gold Scottish stag pin. Beautiful detailing featuring a stag head with amber-coloured stone centrepiece, surrounded by thistle motifs.",
    price: "£45",
    image: "/images/scottish-stag-pin-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 37,
    name: "Lorus Quartz Watch *UNTESTED*",
    category: "jewelry",
    description: "Lorus water resistant quartz watch. Circular face with original Lorus genuine leather strap. Gold-tone case with clear white dial and large numerals. *Untested*",
    price: "£30",
    image: "/images/lorus-watch-1.jpg",
    year: "Vintage",
    condition: "Fair"
  },
  {
    id: 38,
    name: "Constant Quartz Watch *UNTESTED*",
    category: "jewelry",
    description: "Constant quartz watch. Circular face with a two tone band. Stainless steel back, nickel free. Elegant gold and silver design. *Untested*",
    price: "£20",
    image: "/images/constant-watch-1.jpg",
    year: "Vintage",
    condition: "Fair"
  },
  {
    id: 39,
    name: "Sekonda Quartz Watch *UNTESTED*",
    category: "jewelry",
    description: "Sekonda quartz watch with circular face and gold-tone mesh bracelet strap. Stainless steel back. Classic minimalist design. *Untested*",
    price: "£5",
    image: "/images/sekonda-watch-1.jpg",
    year: "Vintage",
    condition: "Fair"
  },
  {
    id: 40,
    name: "Gruen Precision Swiss Watch - 17 Jewels",
    category: "jewelry",
    description: "Gruen Precision Swiss watch, 17 jewels. Textured oval face with a matching metal band. A beautifully crafted gold-tone timepiece with elegant detailing.",
    price: "£60",
    image: "/images/gruen-watch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 41,
    name: "Nephrite Jade Bangle",
    category: "jewelry",
    description: "Beautiful Nephrite jade bangle in a light green shade. A calcium magnesium silicate mineral known for its toughness and durability. Presented in box. Code: 2511-18.",
    price: "£120",
    image: "/images/jade-bangle-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 43,
    name: "Vintage Sterling Silver Gate Bracelet",
    category: "jewelry",
    description: "Vintage sterling silver gate bracelet. Featuring a heart padlock clasp. A classic and elegant piece of silver jewellery.",
    price: "£70",
    image: "/images/gate-bracelet-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 45,
    name: "Silver Horse Head and Whip Pin",
    category: "jewelry",
    description: "Silver horse head and whip pin. Detailed design featuring a finely crafted horse head with a whip-style pin. An elegant equestrian-themed piece.",
    price: "£22",
    image: "/images/horse-whip-pin-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 60,
    name: "925 The Mystical Tutankhamun Charm Collection *FULL SET*",
    category: "jewelry",
    description: "925 The Mystical Tutankhamun Charm Collection featuring 31 charms and a figaro link necklace presented in a fitted case. Comes with the information booklet. A stunning and complete set of Egyptian-themed silver charms.",
    price: "£250",
    image: "/images/tutankhamun-charms-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 74,
    name: "Antique Victorian Mourning Brooch - Hair Art & Seed Pearls",
    category: "jewelry",
    description: "Antique Victorian mourning brooch featuring hair art and seed pearls in a pinchbeck mount. A fascinating and rare piece of Victorian sentimental jewellery with intricate woven hair design under glass.",
    price: "£55",
    image: "/images/mourning-brooch-1.jpg",
    year: "Victorian",
    condition: "Good"
  },
  {
    id: 75,
    name: "Vintage Sterling Silver Owl & Moon Brooch",
    category: "jewelry",
    description: "Lovely vintage sterling silver brooch featuring an owl and moon. Stunning piece with so much detail. The owl has amber-coloured eyes and sits perched on a crescent moon.",
    price: "£38",
    image: "/images/owl-moon-brooch-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 76,
    name: "925 Silver Bottle Pendant Necklace with Silver Flakes",
    category: "jewelry",
    description: "Beautiful 925 silver necklace featuring a bottle pendant with silver flakes inside. A unique and eye-catching piece presented in a gift box.",
    price: "£25",
    image: "/images/silver-bottle-necklace-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 77,
    name: "Vintage 9ct Gold Pearl Drop Earrings with Austrian Crystals",
    category: "jewelry",
    description: "Vintage 9ct gold pearl drop earrings. Contains real Austrian crystals. Elegant teardrop-shaped faux pearl drops with sparkling crystal accents. Code: 2411-43.",
    price: "£78",
    image: "/images/pearl-drop-earrings-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 79,
    name: "Vintage MASJ Signed Poppy Brooch",
    category: "jewelry",
    description: "Vintage MASJ signed poppy brooch. Beautiful design featuring a detailed silver-tone poppy flower with delicate leaves and seed pods. A stunning piece of costume jewellery.",
    price: "£25",
    image: "/images/masj-poppy-brooch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 80,
    name: "925 Silver Lord Ganesh Elephant Pendant on Chain",
    category: "jewelry",
    description: "925 silver Lord Ganesh elephant pendant on a long silver chain. A beautiful depiction of the Hindu deity Ganesh, the remover of obstacles.",
    price: "£30",
    image: "/images/ganesh-pendant-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 81,
    name: "925 Silver Dog Pill Box Necklace - Beagle Design",
    category: "jewelry",
    description: "Dog pill box on a silver necklace. Beautiful beagle on the front. 925 silver. Opens to reveal a small compartment. A charming and unique piece.",
    price: "£65",
    image: "/images/dog-pill-box-necklace-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 82,
    name: "Long Silver Necklace with Rose Gem Pendant",
    category: "jewelry",
    description: "Long silver necklace with pendant. Lovely rose colour gem on the centre of the pendant. Features ornate engraved detailing and a scalloped edge.",
    price: "£60",
    image: "/images/silver-pendant-necklace-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 83,
    name: "Silver Chain and Locket with Engraved Design",
    category: "jewelry",
    description: "Beautiful silver chain and locket. Lovely design on the outer locket with engraved floral motifs. Opens to hold a photograph. A classic and elegant piece.",
    price: "£35",
    image: "/images/silver-locket-chain-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 84,
    name: "9ct Gold Ring with Diamond Cluster and Blue Stone",
    category: "jewelry",
    description: "9ct gold ring with diamond cluster and blue stone. Beautiful ring with a central blue stone surrounded by sparkling diamonds in a classic cluster setting. Code: 2410-65.",
    price: "£128",
    image: "/images/gold-diamond-cluster-ring-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 85,
    name: "Silver Ring - Oval-Cut Centre Stone with Double Halo",
    category: "jewelry",
    description: "Silver ring featuring an oval-cut center stone surrounded by a double halo of smaller stones and a split-shank design. A stunning and elegant piece. Code: 2410-12.",
    price: "£49",
    image: "/images/silver-halo-ring-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 86,
    name: "Diamond White Gold Ring - 0.5ct VVS1 GIA Certified",
    category: "jewelry",
    description: "Diamond white gold ring marked 750 with diamond set shoulders. Principal stone is 0.5ct, colour D, clarity VVS1. Laser inscribed. GIA registry 1126805340. Includes GIA certificate. Size K. Code: 247-1910.",
    price: "£2,700",
    image: "/images/diamond-white-gold-ring-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 87,
    name: "Silver and Gold Stud Earrings with Onyx Stone",
    category: "jewelry",
    description: "Beautiful silver and gold stud earrings with onyx stone. Ornate shield-shaped design with gold accents and central black onyx cabochons. A striking pair.",
    price: "£60",
    image: "/images/onyx-stud-earrings-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 91,
    name: "14ct White Gold 5-Stone Diamond Ring - Marked 585",
    category: "jewelry",
    description: "14ct white gold ring featuring beautiful diamonds. Marked 585. 5-stone diamond setting with brilliant sparkle. Code: 924316.",
    price: "£395",
    image: "/images/white-gold-diamond-ring-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 93,
    name: "9ct Gold Ring with Coloured Gemstones - Size L",
    category: "jewelry",
    description: "9ct gold ring set with superb coloured gemstones. Features a central green stone surrounded by pink, blue, yellow and purple gemstones. Size L. Code: 2410-114.",
    price: "£280",
    image: "/images/gold-gemstone-ring-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 94,
    name: "9ct Gold Eternity Ring with 0.50 Diamond",
    category: "jewelry",
    description: "9ct gold eternity ring with 0.50 diamond. A beautiful and elegant band set with sparkling diamonds around the circumference.",
    price: "£350",
    image: "/images/gold-eternity-diamond-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 95,
    name: "9ct Gold Ring with Sapphire and Diamonds - Size L",
    category: "jewelry",
    description: "Beautiful 9ct gold ring featuring a central sapphire surrounded by diamonds in a classic cluster setting. Size L. Code: 2410-63.",
    price: "£240",
    image: "/images/gold-sapphire-diamond-ring-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 96,
    name: "Vintage 18ct Gold Filigree Bar Brooch with Cameo",
    category: "jewelry",
    description: "Stunning vintage 18ct gold filigree bar brooch with 14ct gold clasp. Featuring a beautiful black and white cameo. Presented in original box. An exquisite piece of fine jewellery.",
    price: "£460",
    image: "/images/gold-filigree-cameo-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 97,
    name: "9ct Gold Necklace with Anchor Pendant - 5.6g",
    category: "jewelry",
    description: "9ct gold necklace with a stunning anchor pendant. Weighs 5.6g. Beautiful nautical-themed piece with detailed anchor and rope design on a curb chain.",
    price: "£230",
    image: "/images/gold-anchor-necklace-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 98,
    name: "Articulated Cloisonne Fish Pendant",
    category: "jewelry",
    description: "Articulated fish pendant featuring cloisonne enamel work. Beautiful colours with a segmented body that moves. Intricate scale detailing in gold, blue and red enamel.",
    price: "£65",
    image: "/images/articulated-fish-pendant-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 99,
    name: "9ct Gold Chain with Dolphin Pendant - 5.6g",
    category: "jewelry",
    description: "9ct gold chain featuring a stunning dolphin pendant. Weighing 5.6g. Beautiful gold curb chain with a detailed leaping dolphin charm.",
    price: "£295",
    image: "/images/gold-dolphin-necklace-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 100,
    name: "9ct Gold Ring with Emerald and Diamonds - 1.8g",
    category: "jewelry",
    description: "Stunning 9ct gold ring with emerald and diamonds. Weighing 1.8g. Features an elegant crossover design with vibrant green emeralds and sparkling diamonds.",
    price: "£155",
    image: "/images/gold-emerald-diamond-ring-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 101,
    name: "9ct Gold Earrings - 3.1g",
    category: "jewelry",
    description: "9ct gold earrings. Weighing 3.1g. Elegant figure-of-eight / infinity style drop earrings in beautiful yellow gold.",
    price: "£160",
    image: "/images/gold-earrings-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 102,
    name: "9ct Gold Curb Link Bracelet with Heart Padlock - 18.7g",
    category: "jewelry",
    description: "9ct gold curb link bracelet and heart padlock clasp. Weighs 18.7g. A substantial and beautifully crafted piece of gold jewellery with hallmarked links.",
    price: "£850",
    image: "/images/gold-curb-bracelet-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 103,
    name: "9ct Gold Ring with Large Oval Moonstone - 5g",
    category: "jewelry",
    description: "Lovely 9ct gold ring featuring a large oval cut moonstone. Weighs 5g. The moonstone displays a beautiful blue sheen (adularescence) set in a classic gold bezel.",
    price: "£200",
    image: "/images/gold-moonstone-ring-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 105,
    name: "9ct Gold Sapphire and White Stone Ring - 3g",
    category: "jewelry",
    description: "Lovely 9ct gold sapphire and white stone ring. Weighing 3g. Features a central dark blue sapphire surrounded by sparkling white stones in a floral cluster setting.",
    price: "£200",
    image: "/images/gold-sapphire-white-ring-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 106,
    name: "9ct Gold Pin with Diamond",
    category: "jewelry",
    description: "9ct gold pin with a beautiful diamond. Features a decorative sunburst/cogwheel design with a central diamond. An elegant and refined piece.",
    price: "£45",
    image: "/images/gold-diamond-pin-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 107,
    name: "9ct Gold Brooch with Three Amethysts - 1.8g",
    category: "jewelry",
    description: "9ct gold brooch weighing 1.8g. Features three round-cut amethysts set in an elegant bar brooch design. A beautiful piece of gold jewellery.",
    price: "£75",
    image: "/images/gold-amethyst-brooch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 108,
    name: "9ct Gold Filigree Heart Lock - 5.6g",
    category: "jewelry",
    description: "9ct gold filigree heart lock. Weighs 5.6g. Beautiful intricate openwork scrolling filigree design. A stunning and romantic piece of gold jewellery.",
    price: "£300",
    image: "/images/gold-filigree-heart-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 109,
    name: "9ct Gold Diamond Ring - 3g",
    category: "jewelry",
    description: "9ct gold diamond ring. Weighs 3g. Beautiful ring featuring a row of pavé-set diamonds in a marquise-shaped setting. An elegant and eye-catching piece.",
    price: "£180",
    image: "/images/gold-diamond-ring-3g-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 110,
    name: "9ct Gold Torque Bangle - 5.8g",
    category: "jewelry",
    description: "9ct gold torque bangle. Weighs 5.8g. Features decorative ribbed ball finials on each end. A classic and elegant gold bangle.",
    price: "£280",
    image: "/images/gold-torque-bangle-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 112,
    name: "Sterling Silver Necklace with Sapphire Stones",
    category: "jewelry",
    description: "Lovely sterling silver necklace with beautiful sapphire stones arranged in a floral or ribbon pattern. A stunning and delicate piece presented in a gift box.",
    price: "£65",
    image: "/images/silver-sapphire-necklace-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 113,
    name: "Original Gucci 18ct Black Gold Necklace - 32 Black Diamonds",
    category: "jewelry",
    description: "Absolutely amazing piece, very rare! Original Gucci 18ct black gold necklace with 32 black diamonds. Original 18ct black-gold chain by Unoaerre design house (18ct gold, black rhodium coated). VGC. Comes with the dust bag.",
    price: "£2,695",
    image: "/images/gucci-black-gold-necklace-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 118,
    name: "Gilt Metal Terrier Brooch",
    category: "jewelry",
    description: "Fantastic gilt metal terrier brooch. Features a detailed terrier dog portrait in a sunburst-style gold frame. A charming piece for any dog lover.",
    price: "£15",
    image: "/images/gilt-terrier-brooch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 120,
    name: "Vintage Carved Bone Pendant - Female Face",
    category: "jewelry",
    description: "Lovely vintage carved bone pendant featuring a beautifully detailed female face with flowing hair. A unique and artistic piece of wearable art.",
    price: "£25",
    image: "/images/carved-bone-pendant-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 121,
    name: "9ct Gold T-Bone Chain - 13g",
    category: "jewelry",
    description: "9ct gold T-Bone chain. Weighs 13g. Beautiful detailing with a classic curb link design and T-bar fastening. A substantial and elegant piece of gold jewellery.",
    price: "£800",
    image: "/images/gold-tbone-chain-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 123,
    name: "Peruvian Sterling Silver Tumi Pendant with Turquoise Inlays",
    category: "jewelry",
    description: "Peruvian Tumi pendant made of sterling silver and inlaid with a green stone, likely turquoise. The Tumi is a traditional Peruvian ceremonial knife. Intricate openwork design on a silver chain.",
    price: "£90",
    image: "/images/peruvian-tumi-pendant-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 125,
    name: "Silver First Holy Communion Pendant with Gold-Toned Chalice",
    category: "jewelry",
    description: "First holy communion pendant. Made of silver with a gold-toned chalice design on the front. Stamped on the back. A lovely religious piece.",
    price: "£25",
    image: "/images/communion-pendant-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 127,
    name: "9ct White Gold Snowflake Stud Earrings - 375",
    category: "jewelry",
    description: "Snowflake stud 9ct white gold 375 earrings. Delicate snowflake design with sparkling stones. Presented in original box.",
    price: "£120",
    image: "/images/snowflake-stud-earrings-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 128,
    name: "Cardinal 21 Jewel Swiss Mechanical Watch",
    category: "jewelry",
    description: "Cardinal 21 jewel mechanical watch. Swiss made. Beautiful black, white and red watch face. Manual winding movement. Silver-toned metal bracelet.",
    price: "£40",
    image: "/images/cardinal-watch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 129,
    name: "18KGP Gold Plated Rope Chain Necklace",
    category: "jewelry",
    description: "Gold plated necklace rope chain. 18KGP. Features intertwined links creating an elegant rope design.",
    price: "£12",
    image: "/images/gold-plated-rope-chain-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 130,
    name: "Patrick Arnaud Quartz Watch",
    category: "jewelry",
    description: "Patrick Arnaud quartz watch. Black watch face and silver-toned metal bracelet. A classic and stylish timepiece.",
    price: "£15",
    image: "/images/patrick-arnaud-watch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 132,
    name: "Diamond Flower Cluster Necklace on Silver Chain",
    category: "jewelry",
    description: "Diamond flower cluster diamond necklace. Clear stones on a beautiful silver chain. Stunning flower-shaped pendant with sparkling diamonds. Presented in original box.",
    price: "£140",
    image: "/images/diamond-flower-necklace-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 133,
    name: "0.75ct Diamond Solitaire Ring - Size K",
    category: "jewelry",
    description: "Beautiful 0.75ct diamond ring. Size K. Round cut solitaire ring. A stunning and classic diamond solitaire with brilliant sparkle. Presented in original box.",
    price: "£700",
    image: "/images/diamond-solitaire-ring-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 134,
    name: "Silver Bangle with Engraving - 23.8g, Hallmarked",
    category: "jewelry",
    description: "Silver bangle with a lovely engraving. 23.8g. Full English hallmarks. A beautiful and substantial piece of silver jewellery. Code: 2603-40.",
    price: "£88",
    image: "/images/silver-engraved-bangle-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 135,
    name: "Vintage Adjustable Sterling Silver Eagle Ring",
    category: "jewelry",
    description: "Vintage adjustable sterling silver ring. Features an eagle's head with a gold toned beak and red stone eyes. A striking and detailed piece.",
    price: "£25",
    image: "/images/eagle-silver-ring-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 136,
    name: "Vintage Crystal Necklace with Gold-Filled Clasp",
    category: "jewelry",
    description: "Vintage crystal necklace with a beautiful gold-filled clasp. Features stunning clear faceted crystal beads in a graduated design. Beautiful shape and sparkle.",
    price: "£25",
    image: "/images/crystal-necklace-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 137,
    name: "Vintage Silver Wheat Chain with Enamel Beads",
    category: "jewelry",
    description: "Vintage silver wheat chain with enamel beads. Features rounded beads and cylindrical accents decorated with colourful enamel work in vibrant red, blue, and green patterns.",
    price: "£120",
    image: "/images/silver-wheat-chain-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 138,
    name: "Sterling Silver Atlantic Salmon Brooch",
    category: "jewelry",
    description: "Sterling silver Atlantic salmon brooch. A beautifully detailed and realistic silver fish brooch presented in a red display box. A wonderful piece for fishing or nature enthusiasts.",
    price: "£45",
    image: "/images/salmon-brooch-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 139,
    name: "925 Chain with Vintage Sterling Silver Crucifix",
    category: "jewelry",
    description: "925 chain with vintage sterling silver crucifix featuring a traditional design with flared or trefoil (three-lobed) ends on each arm. Hallmarked. Presented in box.",
    price: "£30",
    image: "/images/silver-crucifix-chain-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 140,
    name: "Vintage Vendome Adjustable Ring - Red Cabochon Stone",
    category: "jewelry",
    description: "Vintage Vendome adjustable ring. Featuring a central red cabochon stone surrounded by sparkling rhinestones in an Art Deco inspired design. Presented in original red box.",
    price: "£80",
    image: "/images/vendome-ring-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 11,
    name: "Border Fine Arts 'Mouse on Apple Core'",
    category: "collectibles",
    description: "Charming Border Fine Arts figurine of a mouse perched on an apple core. Hand made in Scotland by Ray Ayres. Slight hairline on ear as pictured. A delightful collectible piece.",
    price: "£30",
    image: "/images/mouse-apple-1.jpg",
    year: "Late 20th Century",
    condition: "Good"
  },
  {
    id: 12,
    name: "Border Fine Arts 'Times of Plenty' Wood Mouse",
    category: "collectibles",
    description: "Beautiful Border Fine Arts 'Times of Plenty' wood mouse figurine (BCM02). Hand made in Scotland by Ray Ayres, 1991. A wonderful collectible piece depicting a mouse amid an autumnal harvest.",
    price: "£30",
    image: "/images/mouse-plenty-1.jpg",
    year: "1991",
    condition: "Excellent"
  },
  {
    id: 13,
    name: "Border Fine Arts 'Mouse on Black Grapes'",
    category: "collectibles",
    description: "Delightful Border Fine Arts figurine of a mouse sitting atop a bunch of black grapes. Hand made in Scotland by Ray Ayres, 1989. A charming and highly collectible piece.",
    price: "£30",
    image: "/images/mouse-grapes-1.jpg",
    year: "1989",
    condition: "Excellent"
  },
  {
    id: 14,
    name: "Border Fine Arts 'Mouse on Strawberries'",
    category: "collectibles",
    description: "Lovely Border Fine Arts figurine featuring a mouse nestled among strawberries. Hand made in Scotland by Ray Ayres, 1989. A beautiful collectible piece with fine detail.",
    price: "£30",
    image: "/images/mouse-strawberries-1.jpg",
    year: "1989",
    condition: "Excellent"
  },
  {
    id: 17,
    name: "Taxidermy Gazelle Horns on Wooden Plaque",
    category: "collectibles",
    description: "Taxidermy Gazelle horns mounted on a classic, shield-shaped wooden plaque. The horns are dark, distinctly ridged, and have a slight spiral or lyrical shape, curving backward and then slightly forward. A striking display piece.",
    price: "£120",
    image: "/images/gazelle-horns-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 18,
    name: "Antique African Wooden Ladle",
    category: "collectibles",
    description: "Antique African ladle made from dark wood with a distinctive handcarved design on the handle. A unique and characterful piece of African craftsmanship.",
    price: "£45",
    image: "/images/african-ladle-1.jpg",
    year: "Antique",
    condition: "Good"
  },
  {
    id: 29,
    name: "Swarovski Crystal Blue Tulip Figurine",
    category: "collectibles",
    description: "Swarovski Crystal Blue Tulip figurine. Blue crystal tulip bloom on a clear crystal stem and leaves. 2002 renewal gift for members of the Swarovski Crystal Society (SCS). Presented in original box.",
    price: "£50",
    image: "/images/swarovski-tulip-1.jpg",
    year: "2002",
    condition: "Excellent"
  },
  {
    id: 33,
    name: "Handmade Cow Hoof Bottle - CR Flamengo",
    category: "collectibles",
    description: "Handmade cow hoof bottle, a unique taxidermy item often used as a decanter or flask. Features a small patch displaying the crest of the Brazilian football club CR Flamengo.",
    price: "£40",
    image: "/images/cow-hoof-bottle-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 47,
    name: "White Jade Carved Plaque - Qing Dynasty",
    category: "collectibles",
    description: "White jade carved plaque. Described as being from the Qing dynasty. Intricate openwork carving with traditional Chinese motifs.",
    price: "£40",
    image: "/images/white-jade-plaque-1.jpg",
    year: "Qing Dynasty",
    condition: "Good"
  },
  {
    id: 48,
    name: "Antique Carved Chinese Jade Medallion - Dragon Design",
    category: "collectibles",
    description: "Antique carved Chinese jade medallion featuring a dragon design. Beautiful openwork circular plaque with intricate traditional Chinese motifs.",
    price: "£45",
    image: "/images/jade-medallion-1.jpg",
    year: "Antique",
    condition: "Good"
  },
  {
    id: 51,
    name: "Elliot Hall Enamels 'Daffodils' by N. Creed (26/29)",
    category: "collectibles",
    description: "Elliot Hall Enamels 'Daffodils' enamel box by N. Creed. Number 26 of a limited edition of 29. Signed by the artist. Made in Staffordshire, England. Presented in original box with certificate.",
    price: "£60",
    image: "/images/elliot-hall-daffodils-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 52,
    name: "Elliot Hall Enamels 'Sweet Pea' by E. Todd (6/15)",
    category: "collectibles",
    description: "Elliot Hall Enamels 'Sweet Pea' enamel box by E. Todd. Number 6 of a limited edition of 15. Signed by the artist. Made in Staffordshire, England. Presented in original box with certificate.",
    price: "£120",
    image: "/images/elliot-hall-sweetpea-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 53,
    name: "Elliot Hall Enamels 'Easter 2008' by M. Holloman (70/100)",
    category: "collectibles",
    description: "Elliot Hall Enamels 'Easter 2008' enamel egg by M. Holloman. Number 70 of a limited edition of 100. Signed by the artist. Beautiful hand-painted floral design. Made in Staffordshire, England. Presented in original box with certificate.",
    price: "£65",
    image: "/images/elliot-hall-easter-1.jpg",
    year: "2008",
    condition: "Excellent"
  },
  {
    id: 54,
    name: "Elliot Hall Enamels 'Winter Jasmine' by A. Roberts (4/50)",
    category: "collectibles",
    description: "Elliot Hall Enamels 'Winter Jasmine' enamel box by A. Roberts. Number 4 of a limited edition of 50. Signed by the artist. Made in Staffordshire, England. Presented in original box with certificate.",
    price: "£65",
    image: "/images/elliot-hall-jasmine-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 55,
    name: "Elliot Hall Enamels 'Primroses' by Bath Higham (71/100)",
    category: "collectibles",
    description: "Elliot Hall Enamels 'Primroses' enamel egg by Bath Higham. Number 71 of a limited edition of 100. Signed by the artist. Hand-painted primrose design on a pale blue background. Made in Worcestershire, England. Presented in original box with certificate.",
    price: "£65",
    image: "/images/elliot-hall-primroses-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 56,
    name: "Elliot Hall Enamels 'Easter 2007' by Fiona Bakewell (60/100) *AF*",
    category: "collectibles",
    description: "Elliot Hall Enamels 'Easter 2007' enamel egg by Fiona Bakewell. Number 60 of a limited edition of 100. Hand-painted floral design with crocus and daffodils. *AF - as found*. Presented in original box.",
    price: "£35",
    image: "/images/elliot-hall-easter2007-1.jpg",
    year: "2007",
    condition: "Fair"
  },
  {
    id: 57,
    name: "Antique Gilt Enamel Cloisonne Crucifix & Holy Water Font",
    category: "collectibles",
    description: "Antique gilt enamel cloisonne crucifix and holy water font in bronze on white marble. French Napoleon 3rd period. Stunning intricate cloisonne enamel work in vibrant blues, reds and golds.",
    price: "£220",
    image: "/images/cloisonne-crucifix-1.jpg",
    year: "Napoleon III",
    condition: "Good"
  },
  {
    id: 63,
    name: "Czech Rhinestone Christmas Tree",
    category: "collectibles",
    description: "Beautiful Czech rhinestone Christmas tree. Sparkling green rhinestones set into a tree-shaped metal frame on a decorative star base with a large green crystal centre. A lovely festive display piece.",
    price: "£70",
    image: "/images/czech-christmas-tree-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 64,
    name: "Pair of Vintage Turned Wood & Brass Candlestick Holders",
    category: "collectibles",
    description: "Lovely pair of vintage candlestick holders featuring turned wood and brass. Beautifully crafted with a classic baluster shape and polished brass accents.",
    price: "£38",
    image: "/images/candlestick-holders-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 65,
    name: "Radio-Controlled Scale Model Patrol Boat *UNTESTED*",
    category: "collectibles",
    description: "Radio-controlled scale model of a military patrol or rescue boat. Loads of detail and hand made. Comes with Sanwa digital proportional radio control system. *Untested*",
    price: "£130",
    image: "/images/rc-patrol-boat-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 67,
    name: "Yard of Ale Drinking Glass with Box",
    category: "collectibles",
    description: "Yard of Ale drinking glass with box. Sometimes called a 'coachman's glass', holding around 2.4 to 3 pints of liquid. Features decorative fleur-de-lis pattern around the rim. An unusual and fun decorative piece.",
    price: "£35",
    image: "/images/yard-of-ale-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 104,
    name: "Yellow Metal Propelling Pencil with Turquoise Cabochons",
    category: "collectibles",
    description: "Beautiful yellow metal propelling pencil with turquoise cabochons. A charming and unusual antique writing instrument with decorative turquoise stone accents.",
    price: "£65",
    image: "/images/propelling-pencil-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 111,
    name: "Carved Moonstone Rabbit Figurine",
    category: "collectibles",
    description: "Carved moonstone rabbit figurine. Absolutely beautiful little piece. The translucent opalescent moonstone gives it a magical, ethereal quality.",
    price: "£25",
    image: "/images/moonstone-rabbit-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 119,
    name: "Tortoise Shell Comb with Silver Mounted Rim",
    category: "collectibles",
    description: "Tortoise shell comb with a beautiful silver mounted rim. Featuring ornate repousse scrollwork along the silver edge. A lovely antique hair accessory.",
    price: "£25",
    image: "/images/tortoise-shell-comb-1.jpg",
    year: "Antique",
    condition: "Good"
  },
  {
    id: 124,
    name: "Chinese Carved Jade Amulet - Dragon Design",
    category: "collectibles",
    description: "Chinese carved jade amulet. Carved from pale green or white jade and features intricate, archaic-style carvings, possibly depicting a dragon. A beautiful piece of Chinese craftsmanship.",
    price: "£30",
    image: "/images/jade-chinese-amulet-1.jpg",
    year: "Antique",
    condition: "Good"
  },
  {
    id: 8,
    name: "Moorcroft 'In Flanders Field' Clock",
    category: "ceramics",
    description: "Limited edition Moorcroft clock designed by Rachel Bishop. Features rich, blazing-red poppies against a pale yellow, or 'golden corn,' background. A stunning collectible piece.",
    price: "£140",
    image: "/images/moorcroft-clock-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 9,
    name: "Vintage Caithness Glass Scent Bottle",
    category: "ceramics",
    description: "Vintage hand-made art glass scent bottle by Caithness Glass. Features a beautiful blue and white swirl design in the glass body. Made in a factory in Scotland during the late 20th century.",
    price: "£25",
    image: "/images/caithness-glass-1.jpg",
    year: "Late 20th Century",
    condition: "Excellent"
  },
  {
    id: 10,
    name: "Clarice Cliff Bizarre 'Biyanne' Square Pot",
    category: "ceramics",
    description: "Clarice Cliff Bizarre 'Biyanne' square pot. Beautifully hand painted bone china with rare pattern featuring bold geometric orange, red and green design. Highly collectible.",
    price: "£140",
    image: "/images/clarice-cliff-pot-1.jpg",
    year: "Art Deco",
    condition: "Excellent"
  },
  {
    id: 15,
    name: "19th Century Victorian Transferware Tile",
    category: "ceramics",
    description: "19th century Victorian transferware tile featuring a classical Greco-Roman landscape scene. Depicts architectural ruins, a body of water, and farm animals in the foreground. A beautiful piece of Victorian decorative art.",
    price: "£100",
    image: "/images/victorian-tile-1.jpg",
    year: "19th Century",
    condition: "Good"
  },
  {
    id: 19,
    name: "Myott, Son & Co. Art Deco Ceramic Jugs",
    category: "ceramics",
    description: "Myott, Son & Co. hand-painted ceramic jugs, dating to the Art Deco period of the 1930s. Made in England. Features charming floral design with orange sunflower motifs. Pattern number 9039.",
    price: "£45",
    image: "/images/myott-jugs-1.jpg",
    year: "1930s",
    condition: "Good"
  },
  {
    id: 27,
    name: "Victorian Staffordshire Dog Figurine",
    category: "ceramics",
    description: "Victorian style Staffordshire dog figurine. Known for its hand-painted eyes and facial features. A charming classic piece of English pottery.",
    price: "£25",
    image: "/images/staffordshire-dog-1.jpg",
    year: "Victorian",
    condition: "Good"
  },
  {
    id: 28,
    name: "Vintage Mdina Art Glass Bowl 'Sea and Sand'",
    category: "ceramics",
    description: "Vintage Mdina art glass bowl or dish. Features the 'Sea and Sand' colorway, characterized by swirling layers of blue, green, and yellow glass. Distinctive organic, hand-blown shape with a scroll-like handle at one end.",
    price: "£15",
    image: "/images/mdina-glass-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 30,
    name: "Royal Crown Derby Cup and Saucer - Imari Design",
    category: "ceramics",
    description: "Royal Crown Derby cup and saucer. Made from fine bone china. The set features a traditional Imari design characterized by a vibrant combination of cobalt blue, orange, and rich gold gilding.",
    price: "£40",
    image: "/images/royal-crown-derby-cup-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 31,
    name: "Royal Crown Derby Saucer - Old Imari 1128 Pattern",
    category: "ceramics",
    description: "Royal Crown Derby saucer. Iconic Old Imari 1128 pattern. Been a favourite since the 1800s and is characterized by its rich cobalt blue, burnt orange, and 22-karat gold decoration.",
    price: "£15",
    image: "/images/royal-crown-derby-saucer-1.jpg",
    year: "1800s",
    condition: "Good"
  },
  {
    id: 32,
    name: "Troika Coffin Vase with Cross Motif",
    category: "ceramics",
    description: "Troika coffin vase with cross motif. Circa 1975, signed S/K. Hand painted. A desirable collectible from the iconic British factory, Troika Cornwall.",
    price: "£175",
    image: "/images/troika-vase-1.jpg",
    year: "c.1975",
    condition: "Good"
  },
  {
    id: 49,
    name: "Moorcroft Trial Vase - 17 Inches",
    category: "ceramics",
    description: "Moorcroft trial vase. 17 inches tall. Beautiful intricate floral design with vibrant colours. Marked on the bottom 'W Moorcroft'. A stunning and highly collectible piece.",
    price: "£600",
    image: "/images/moorcroft-vase-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 50,
    name: "Pair of Sitzendorf Porcelain Wall Brackets - Cherub Design",
    category: "ceramics",
    description: "A pair of Sitzendorf porcelain wall brackets featuring an intricate design with a cherub (putto) collecting flowers. The mark visible dates the piece to between approximately 1884 and 1902.",
    price: "£240",
    image: "/images/sitzendorf-brackets-1.jpg",
    year: "1884-1902",
    condition: "Good"
  },
  {
    id: 58,
    name: "Wedgwood Willow Clock *UNTESTED*",
    category: "ceramics",
    description: "Wedgwood willow clock. Beautiful piece produced exclusively for the Danbury Mint. Fine earthenware, made in England. Features the classic blue and white willow pattern with gold accents and a gold lion finial. *Untested*",
    price: "£70",
    image: "/images/wedgwood-clock-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 62,
    name: "First Period Worcester Porcelain Cup and Saucer Set",
    category: "ceramics",
    description: "First period Worcester porcelain cup and saucer set dating from around 1770. The Dr. Wall period of the Worcester factory. Beautifully decorated with rich cobalt blue, orange, and gilt patterns.",
    price: "£220",
    image: "/images/worcester-cup-saucer-1.jpg",
    year: "c.1770",
    condition: "Good"
  },
  {
    id: 66,
    name: "Vintage Chelsea Square Dish Bowl - 1960s Floral Design",
    category: "ceramics",
    description: "Vintage Chelsea square dish bowl. 1960s floral design featuring bold hand-painted sunflower motifs. A lovely retro piece of studio pottery.",
    price: "£30",
    image: "/images/chelsea-dish-bowl-1.jpg",
    year: "1960s",
    condition: "Good"
  },
  {
    id: 69,
    name: "Vintage Asian Hand-Carved Soapstone Vase",
    category: "ceramics",
    description: "Vintage Asian hand-carved soapstone vase. Features intricate floral carvings with chrysanthemum blooms and leaves. A beautiful example of traditional Asian stone carving artistry.",
    price: "£30",
    image: "/images/soapstone-vase-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 70,
    name: "Moorcroft 'Finch and Fruit' Pattern Vase",
    category: "ceramics",
    description: "Moorcroft Finch and Fruit pattern vase introduced in the late 1980s. The vase uses Moorcroft's signature tubelined and hand-painted technique. Stunning deep blue and pink tones with a bird and berry design. Twin-handled form.",
    price: "£290",
    image: "/images/moorcroft-finch-fruit-1.jpg",
    year: "Late 1980s",
    condition: "Excellent"
  },
  {
    id: 71,
    name: "Moorcroft 'Queens Choice' Pattern Vase",
    category: "ceramics",
    description: "Moorcroft Queens Choice pattern. Lovely design. Date cyphered 2002. Beautiful deep blue and green tones with bold floral and fruit motifs. A highly collectible Moorcroft piece.",
    price: "£230",
    image: "/images/moorcroft-queens-choice-1.jpg",
    year: "2002",
    condition: "Excellent"
  },
  {
    id: 72,
    name: "Moorcroft 'Hartgring' Twin-Handled Vase",
    category: "ceramics",
    description: "Moorcroft 'Hartgring' twin-handled vase featuring a beautiful design with rich red and crimson floral motifs on a cream and grey ground. A stunning and collectible piece.",
    price: "£290",
    image: "/images/moorcroft-hartgring-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 122,
    name: "Royal Crown Derby Side Plate - Imari Pattern",
    category: "ceramics",
    description: "Royal Crown Derby side plate. Beautiful colours and design featuring the iconic Imari pattern with vibrant cobalt blue, orange, and gold floral motifs.",
    price: "£45",
    image: "/images/royal-crown-derby-plate-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 126,
    name: "Noritake Espresso Cups and Saucers Set",
    category: "ceramics",
    description: "Noritake espresso cups and saucers. Beautiful vibrant colours including blue, black, red, and green, each with elegant gold trim. £45 for the set.",
    price: "£45",
    image: "/images/noritake-espresso-set-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 20,
    name: "Silver Middlesbrough & District Football League Medal",
    category: "collectibles",
    description: "Silver Middlesbrough and district football league medal. Dated 1920-21. Featuring the blue lion rampant which is associated with the de Brus family, who were early lords of the area. Engraved 'League Runners Up 1920-21'.",
    price: "£25",
    image: "/images/middlesbrough-medal-1.jpg",
    year: "1920-21",
    condition: "Good"
  },
  {
    id: 42,
    name: "Art Nouveau Miniature Sterling Silver Picture Frame",
    category: "collectibles",
    description: "Nouveau style miniature sterling silver picture frame. Featuring a lady on the framework with flowing floral vine detailing. A charming decorative piece.",
    price: "£60",
    image: "/images/nouveau-frame-1.jpg",
    year: "Art Nouveau",
    condition: "Good"
  },
  {
    id: 44,
    name: "925 Sterling Silver Pin Cushion",
    category: "collectibles",
    description: "925 sterling silver pin cushion with pin. A lovely and practical antique silverware piece with blue fabric cushion top.",
    price: "£55",
    image: "/images/pin-cushion-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 46,
    name: "George V Silver Pickle Stick",
    category: "collectibles",
    description: "George V silver pickle stick with decorative handle featuring an amber-coloured stone detail. A charming piece of antique silverware.",
    price: "£45",
    image: "/images/pickle-stick-1.jpg",
    year: "George V Era",
    condition: "Good"
  },
  {
    id: 73,
    name: "Scottish Sterling Silver Sword Kilt Pin",
    category: "jewelry",
    description: "Amazing quality Scottish sterling silver sword kilt pin. Features a classic sword shape with Celtic detailing on the hilt. Hallmarked. A beautiful piece of Scottish silverwork.",
    price: "£45",
    image: "/images/scottish-kilt-pin-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 78,
    name: "French Silver Cloak Pin - 19th Century",
    category: "jewelry",
    description: "French silver cloak pin. Beautiful design dating back to the 19th century. Features ornate shell-like medallions connected by a chain with intricate repousse work.",
    price: "£95",
    image: "/images/french-cloak-pin-1.jpg",
    year: "19th Century",
    condition: "Good"
  },
  {
    id: 88,
    name: "Solid Silver Mantle Clock and Candlesticks Set",
    category: "collectibles",
    description: "Solid silver mantle clock and candlesticks. Beautiful intricate design and hallmarked. A magnificent set featuring ornate Corinthian column design with detailed scrollwork and floral motifs.",
    price: "£1,300",
    image: "/images/silver-mantle-clock-1.jpg",
    year: "Antique",
    condition: "Excellent"
  },
  {
    id: 89,
    name: "925 Sterling Silver Tricycle",
    category: "collectibles",
    description: "925 sterling silver tricycle. Beautiful little vintage piece with incredible detail. A charming miniature silver model.",
    price: "£55",
    image: "/images/silver-tricycle-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 90,
    name: "925 Silver Bicycle with Moveable Features",
    category: "collectibles",
    description: "Stunning 925 silver bicycle. Incredible detail with moveable features including wheels, pedals and handlebars. A remarkable piece of silver craftsmanship.",
    price: "£85",
    image: "/images/silver-bicycle-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 92,
    name: "Large Solid Silver Ship on Marble Stand - Hallmarked",
    category: "collectibles",
    description: "Large solid silver ship with beautiful intricate design. Hallmarked on every piece of silver. Comes on a marble stand with engraved plaque awarded to Walter Warburton 1926. A magnificent and rare piece.",
    price: "£5,000",
    image: "/images/silver-ship-1.jpg",
    year: "1926",
    condition: "Excellent"
  },
  {
    id: 115,
    name: "Antique 925 Silver Tennis-Themed Vesta Case",
    category: "collectibles",
    description: "Tennis themed antique vesta case. 925 silver. Features a beautifully embossed tennis player in action on the front with racquet net detail. A charming sporting collectible.",
    price: "£60",
    image: "/images/tennis-vesta-case-1.jpg",
    year: "Antique",
    condition: "Good"
  },
  {
    id: 131,
    name: "Charles Horner 'Dorcas' Silver Thimble - Size 3",
    category: "collectibles",
    description: "Charles Horner 'Dorcas' thimble. Size 3. Beautiful engravings with intricate floral pattern band. A highly collectible piece by the renowned Charles Horner of Halifax.",
    price: "£12",
    image: "/images/charles-horner-thimble-1.jpg",
    year: "Antique",
    condition: "Good"
  },
  {
    id: 59,
    name: "Genuine Alabaster Kneeling Female Figure - Art Deco",
    category: "sculpture",
    description: "Genuine alabaster kneeling nude female figure. Art Deco aesthetic. A beautifully carved piece with graceful pose and warm tone.",
    price: "£50",
    image: "/images/alabaster-figure-1.jpg",
    year: "Art Deco",
    condition: "Good"
  },
  {
    id: 61,
    name: "The Franklin Mint Bronze Elephant",
    category: "sculpture",
    description: "Absolutely beautiful The Franklin Mint bronze elephant. The detail on this is amazing. A stunning sculpture with incredible craftsmanship featuring gold-tone tusks and a powerful striding pose.",
    price: "£120",
    image: "/images/franklin-mint-elephant-1.jpg",
    year: "Vintage",
    condition: "Excellent"
  },
  {
    id: 68,
    name: "Genuine Alabaster Greek Goddess Artemis Figure",
    category: "sculpture",
    description: "Genuine alabaster Greek figure made in Italy. Greek Goddess Artemis (Roman equivalent Diana). Potentially by G. Ruggeri. An amazing piece with fine detail and classical pose.",
    price: "£70",
    image: "/images/alabaster-artemis-1.jpg",
    year: "Vintage",
    condition: "Good"
  },
  {
    id: 4,
    name: "Pair of London Paintings - Signed David",
    category: "art",
    description: "Oil on canvas signed David. Large pictures of London - one featuring the London Eye with red accents and the other a monochrome London scene with Big Ben, accented by a single red tree.",
    price: "£150",
    image: "/images/london-paintings-1.jpg",
    year: "Contemporary",
    condition: "Excellent"
  },
  {
    id: 16,
    name: "Amos Green Watercolour - 'Til-y-din, North Wales'",
    category: "art",
    description: "Framed original watercolour painting by the British artist Amos Green, titled 'Til-y-din, North Wales'. Dated 1735-1807. Depicts a rural landscape scene with a figure near a body of water and a building in the background.",
    price: "£120",
    image: "/images/amos-green-painting-1.jpg",
    year: "1735-1807",
    condition: "Good"
  },
  {
    id: 114,
    name: "19th Century Portrait of a Gentleman in Leather Folding Case",
    category: "art",
    description: "19th century hand-painted portrait miniature of a gentleman in a beautiful leather folding case. A wonderful example of Victorian portrait art with fine detailing.",
    price: "£200",
    image: "/images/portrait-leather-case-1.jpg",
    year: "19th Century",
    condition: "Good"
  }
];

export const categories = [
  { id: "all", name: "All Items", icon: "Grid3x3" },
  { id: "jewelry", name: "Jewelry & Watches", icon: "Watch" },
  { id: "collectibles", name: "Collectibles & Figurines", icon: "Heart" },
  { id: "ceramics", name: "Ceramics & Pottery", icon: "Wine" },
  { id: "sculpture", name: "Sculpture & Bronze", icon: "Sparkles" },
  { id: "art", name: "Art & Paintings", icon: "Palette" }
];

export const storeInfo = {
  name: "J.B.F. Antiques & Gallery",
  address: "Doncaster Corn Exchange, Doncaster DN1 1NJ, United Kingdom",
  phone: "+44 7523 414727",
  email: "Justineledodman@gmail.com",
  coordinates: { lat: 53.5244, lng: -1.1333 },
  mapUrl: "https://www.google.com/maps?q=GVF8+QV+Doncaster,+United+Kingdom",
  facebookUrl: "https://www.facebook.com/share/18HLp4YjZz/",
  openingHours: {
    days: "Tuesday - Saturday",
    hours: "9:00 AM - 4:00 PM"
  }
};

export const blogPosts = [
  {
    id: 1,
    title: "Caring for Your Antique Furniture",
    excerpt: "Essential tips for maintaining and preserving the beauty of your antique furniture pieces.",
    date: "2024-01-15",
    author: "J.B.F. Antiques",
    image: "https://images.unsplash.com/photo-1556912998-c57cc6b63cd7?w=800&q=80"
  },
  {
    id: 2,
    title: "New Arrivals: Victorian Collection",
    excerpt: "Discover our latest collection of Victorian antiques, including rare furniture and decorative pieces.",
    date: "2024-01-08",
    author: "J.B.F. Antiques",
    image: "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=800&q=80"
  },
  {
    id: 3,
    title: "The History of Doncaster Corn Exchange",
    excerpt: "Learn about the rich history of our beautiful location and its significance to the local community.",
    date: "2023-12-20",
    author: "J.B.F. Antiques",
    image: "https://images.unsplash.com/photo-1566127444979-b3d2b3c1f1b7?w=800&q=80"
  }
];
